import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ParametersPage = lazy(() => import('~/features/configuration/pages/parameters-page'));

/** `category` is the selected rail item (a category UUID, or `'all'`) — kept
 *  in the URL so the rail selection survives refresh and bookmarks. */
const searchSchema = z.object({
  category: z.string().catch('all').default('all'),
});

/**
 * Configuration Manager — Parameters tab at `/configuration/manager/parameters`.
 * Wrapped by the `/configuration/manager` layout (`manager.tsx`).
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/manager/parameters')({
  validateSearch: searchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ParametersPage />
    </Suspense>
  ),
});
